import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../_models/index';
import { environment } from '../../environments/environment';

var URL = environment.url_django;

@Injectable()
export class UserService {
    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get<User[]>(URL+'pss_app/users/');
    }
    getTeams() {
        return this.http.get<Object[]>(URL+'pss_app/teams/');
    }
    getById(id: number) {
        console.log(URL+'pss_app/users/' + id)
        return this.http.get(URL+'pss_app/users/' + id+'/');
    }
    create(user: User) {
        return this.http.post(URL+'auth/users/create/', user);
    }
    update(user: User) {
        return this.http.put(URL+'pss_app/users/'+user.id+'/', user);
    }
    delete(id: number) {
        return this.http.delete('/api/users/' + id);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts